// @flow
import { Component, createContext, h  } from 'preact';
import ThemeConfig from "./ThemeConfig";

/** `<ThemeConfigProvider>` is a nestable theme configuration provider.
 *	It exposes a theme configuration into the tree,
 *	making it available to descendant components.
 *
 *	@name ThemeConfigProvider
 *	@param props
 *	@param {Object} [props.theme]			Nest `definition` under a root key, and set the active scope for the tree (essentially prefixing all `<Text />` keys).
 *
 *	@example
 *	// themeConfig is generally retrived the Widget conf parsed JSON.
 *
 *	<ThemeConfigProvider conf={conf}>
 *		<div style={`color:${themeConfig.color1}`}>The Foo</div>
 *	</ThemeConfigProvider>
 */
 const fontFamily = [
        {
          id: 1,
          value: "'Open Sans', sans-serif"
        },
        {
          id: 2,
          value: "'Indie Flower', cursive"
        },
        {
          id: 3,
          value: "'Poiret One', cursive"
        },
        {
          id: 4,
          value: "'Lobster', cursive"
        },
        {
          id: 5,
          value: "'Rochester', cursive"
        },
        {
          id: 6,
          value: "'Poppins', sans-serif"
        },
        {
          id: 7,
          value: "'Balthazar', serif"
        },
        {
          id: 8,
          value: "'Concert One', cursive"
        },
        {
          id: 9,
          value: "'Roboto Slab', serif"
        },
        {
          id: 10,
          value: "'Rokkitt', serif"
        },
        {
          id: 11,
          value: "'Sanchez', serif"
        }
      ];

 class ThemeConfigProvider extends Component {
  render() {
    const mergedProps = {
      ...this.props,
      conf: {
        ...this.props.conf,
        fontFamily: this.props.conf ? fontFamily.find(font => font.id === parseInt(this.props.conf.font))?.value : null
      }
    };
    const { children } = this.props ? mergedProps : this.props;

    return (
      <ThemeConfig.Provider value={mergedProps.conf}>
        { children }
      </ThemeConfig.Provider>
    );
  }
}

export default ThemeConfigProvider
